import { useForm } from '@mantine/form';
import { BaseResult, ConfigDataType, CreateCampaignRequest, FundAutoComplete } from '../../types';
import { Button, Modal, Text } from '@mantine/core';
import BasicCampaignForm from '../../routes/campaigns/basic_campaign_form';
import { useDisclosure } from '@mantine/hooks';
import { useFunctions, useFirestore } from '../../helpers/firebaseContext';
import { useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { ConfigContext } from '../../contexts';
import { DocumentReference, updateDoc } from 'firebase/firestore';
import { notifications } from '@mantine/notifications';


const CreateFundCampaignButton = ({
    fund,
    variables,
    documentRef,
    existingCampaignId
}: {
    fund?: FundAutoComplete,
    variables?: Record<string, any>,
    documentRef?: DocumentReference,
    existingCampaignId?: string
}) => {

    const [opened, { open, close }] = useDisclosure(false);
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const [errMsg, setErrMsg] = useState<string>();
    const config: ConfigDataType = useContext(ConfigContext);

    const functions = useFunctions();
    const db = useFirestore();
    const navigate = useNavigate();



    const initialFormValues = useMemo(() => ({
        title: fund?.label,
        rmRecipients: [],
        segmentsRecipients: [],
        customerRecipients: [],
        tagsRecipients: fund?.id ? [fund?.id] : [],
        smsMessage: "",
        messageVariables: { ...variables, fundName: (fund?.label || "") },
        type: [],
        updateLink: {
            updateType: "broadcast" as const,
        },
    }), [fund?.label, fund?.id, variables]);

    const campaignForm = useForm<CreateCampaignRequest>({
        initialValues: initialFormValues,
    });

    useEffect(() => {
        if (fund && config?.factsheetTemplates) {
            campaignForm.setFieldValue("type", ["email", "whatsapp"])
        }
    }, [fund, config?.factsheetTemplates, campaignForm])

    const handleFormSubmit = useCallback(async (values: any) => {
        setErrMsg(undefined)

        if (values.customerRecipients.length <= 0 && values.tagsRecipients.length <= 0 && values.segmentsRecipients.length <= 0) {
            setErrMsg("either customers or tags/segments need to be added");
            return;
        }
        if (values.type.length <= 0) {
            setErrMsg("atleast one type must be selected");
            return;
        }

        setLoadingSubmit(true)
        try {
            const createCampaign = httpsCallable<CreateCampaignRequest, BaseResult>(functions, "createCampaign");
            const response = await createCampaign(values)
            console.log("response.data ========>>", documentRef?.id);

            // Update fund report with campaign ID if documentRef is provided
            if (documentRef && response.data?.data?.campaignId) {
                try {
                    const updatedDoc = await updateDoc(documentRef, {
                        CAMPAIGN_ID: response.data.data.campaignId,
                        CAMPAIGN_CREATED_AT: new Date()
                    });
                } catch (updateError) {
                    console.error("Failed to update fund report with campaign ID:", updateError);
                }
            }

            setLoadingSubmit(false);
            notifications.show({
                title: 'Campaign Created Successfully',
                message: "Campaign created successfully",
                color: 'green',
            });
            // navigate("/campaigns");
            return;

        } catch (e: any) {
            if (e?.message) {
                setErrMsg(e?.message)
            } else {
                setErrMsg("an unexpected error has occurred ")
            }
            setLoadingSubmit(false);
        }
    }, [functions, documentRef, navigate]);

    const handleModalClose = useCallback(() => {
        campaignForm.reset();
        close();
    }, [campaignForm, close]);

    return (
        <>
            {fund ?
                <>
                    <Modal

                        size={"70%"}
                        opened={opened}


                        onClose={handleModalClose} title='Please Select Campaign Type'>
                        <form
                            onSubmit={campaignForm.onSubmit(handleFormSubmit)}
                        >

                            {useMemo(() => (
                                <BasicCampaignForm form={campaignForm} funds={[fund]} />
                            ), [campaignForm, fund])}

                            <Text c={"red"}>
                                {errMsg}
                            </Text>

                            <Button
                                loading={loadingSubmit}
                                type='submit'
                            >
                                Submit
                            </Button>
                        </form>
                    </Modal>
                    <Button
                        variant="light"
                        color={existingCampaignId ? "green" : "blue"}
                        onClick={existingCampaignId ? () => navigate(`/campaigns/edit/${existingCampaignId}`) : open}
                    >
                        {existingCampaignId ? "View Campaign" : "Create Campaign"}
                    </Button>
                </>
                : <>


                    {/* //no fund ID ?? (not sure if possible but just in case) */}
                    <Text>Invalid Fund ID </Text>
                </>}
        </>
    )
}

export default CreateFundCampaignButton